import React from 'react';
import styled from "styled-components"
import propTypes from 'prop-types';

const StyledInput = styled.input`
  ::placeholder {
    font-weight: bold;
  }
  &:focus {
    outline: none;
  }
`

const TBInput = ({type = 'text', label='', value, name='name', placeholder = '', handleChange, onKeyDown}) => {
  return (
    <div className={'tb-input'}>
      <label className={'label'}>
        {label}
        <StyledInput
          className={'tb-inside-input'}
          type={type}
          value={value}
          name={name}
          placeholder={placeholder}
          onChange={handleChange}
          onKeyDown={onKeyDown}
        />
      </label>
    </div>
  )
}

TBInput.propTypes = {
    type: propTypes.string,
    label: propTypes.string,
    value: propTypes.string,
    placeholder: propTypes.string,
    handleChange: propTypes.func,
    onKeydown: propTypes.func
}

export default TBInput;